// src/pages/bloomterminal/alerts/steps/SpecificAlertTypeSelector.jsx
import React from 'react';
import { Check } from 'lucide-react';
import { useGlobalFontSize } from '../../../context/GlobalFontSizeContext';
import {
  PriceIncreaseIcon,
  VolumeChangeIcon,
  WeatherImpactIcon,
  SeasonalIcon,
} from '../assets/alertTypeIcons';

const AlertTypeItem = ({ alertType, checked, onToggle }) => {
  const { fontSize } = useGlobalFontSize();
  const IconComponent = alertType.icon;
  return (
    <button
      onClick={onToggle}
      className={`w-full h-16 border rounded-[8px] flex items-center justify-between px-4 py-2 transition-colors ${
        checked
          ? 'border-bloom-green bg-bloom-green/5'
          : 'border-[#828382] bg-transparent hover:border-bloom-green/50'
      }`}
    >
      <div className="flex items-center gap-3">
        <IconComponent size={16} className="flex-shrink-0" />
        <div className="flex flex-col items-start gap-[2px]">
          <span 
            className="font-['Inter'] font-semibold text-[#282A29] dark:text-white text-left"
            style={{ fontSize: fontSize + 2 }}
          >
            {alertType.title}
          </span>
          <span 
            className="font-['Inter'] font-normal text-[#828382] dark:text-[#f0f5f2] text-left"
            style={{ fontSize: fontSize }}
          >
            {alertType.description}
          </span>
        </div>
      </div>
      <div
        className={`w-4 h-4 rounded border-2 flex items-center justify-center flex-shrink-0 ${
          checked
            ? 'border-bloom-green bg-bloom-green'
            : 'border-bloom-green bg-transparent'
        }`}
      >
        {checked && <Check size={12} className="text-white" strokeWidth={3} />}
      </div>
    </button>
  );
};

const SpecificAlertTypeSelector = ({ selectedSpecificAlertType, onSpecificAlertTypeToggle }) => {
  const { fontSize } = useGlobalFontSize();
  const alertTypes = [
    {
      id: 'fob_price_alert',
      title: 'FOB price alert',
      description: 'Get notified when FOB prices change',
      icon: PriceIncreaseIcon,
    },
    {
      id: 'volume',
      title: 'Volume change alert',
      description: 'Get notified of volume changes',
      icon: VolumeChangeIcon,
    },
    {
      id: 'weather',
      title: 'Weather impact alert',
      description: 'Get notified about weather events',
      icon: WeatherImpactIcon,
    },
    {
      id: 'market',
      title: 'Market impact alert',
      description: 'Get notified about events that impact the market',
      icon: SeasonalIcon,
    },
  ];

  return (
    <div className="flex flex-col gap-12 flex-1">
      <div className="flex flex-col gap-3">
        <h3 
          className="font-['Inter'] font-medium text-[#282A29] dark:text-white"
          style={{ fontSize: fontSize }}
        >
          What type of changes do you want to be alerted about?
        </h3>
        <div className="flex flex-col gap-[6px]">
          {alertTypes.map((alertType) => (
            <AlertTypeItem
              key={alertType.id}
              alertType={alertType}
              checked={selectedSpecificAlertType === alertType.id}
              onToggle={() => onSpecificAlertTypeToggle(alertType.id)}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default SpecificAlertTypeSelector;

